// extracted by mini-css-extract-plugin
export default {"form":"SortBy_form__HtE02","select":"SortBy_select__bomZ4"};